import { path } from 'ramda';
import { IOfferState } from '../../types/reducers/offer';

/**
 *
 * @description Возвращает id бизнес-центра
 */
export function getBusinessCenterId(offer: IOfferState): number | undefined {
  return path<number>(['businessShoppingCenter', 'id'], offer);
}
